import { Marker } from "@react-google-maps/api"
import React, { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DISPATCH_SELECT_ORDER } from "store/dispatch.redux"
import { isToday } from "utils/date-utils"

const OrderMarker = ({
  orders,
  location,
  onMouseOver,
  onMouseOut,
  showSerial,
}) => {
  const dispatch = useDispatch()
  const isSelected = useSelector((state: any) => {
    const selected = state.dispatch.selectedOrders
    return orders?.some(o => selected.get(o.id))
  })

  const handleSelect = useCallback(() => {
    orders &&
      orders.forEach(ord => {
        dispatch({
          type: DISPATCH_SELECT_ORDER,
          payload: ord,
        })
      })
  }, [dispatch, orders])

  const orderSerials = orders?.map(o => o?.index)

  const today = orders?.some(o => isToday(o?.date))

  return (
    <Marker
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      opacity={today || isSelected ? 1 : 0.6}
      icon={
        !isSelected
          ? {
              url: `http://maps.google.com/mapfiles/ms/icons/${
                today ? "yellow-dot.png" : "blue-dot.png"
              }`,
              scaledSize: new window.google.maps.Size(42, 68 * 0.6),
            }
          : undefined
      }
      onClick={handleSelect}
      animation={window.google.maps.Animation.DROP}
      position={location}
      label={showSerial ? `${orderSerials[0] + 1}` : undefined}
    />
  )
}

export default OrderMarker
